/**
 * @generated SignedSource<<3dce93f3371d59c2d0980e70f3cd186d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchListRepo$data = {
  readonly isArchived: boolean;
  readonly isDisabled: boolean;
  readonly isLocked: boolean;
  readonly owner: {
    readonly issueTypesEnabled: boolean;
  };
  readonly viewerCanPush: boolean;
  readonly " $fragmentType": "SearchListRepo";
};
export type SearchListRepo$key = {
  readonly " $data"?: SearchListRepo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchListRepo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchListRepo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDisabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "issueTypesEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "d92f1fffebcd047b26eb2f7e878a714d";

export default node;
